class Route {
    constructor(parameters) {
        this.name = parameters.name ?? null;
        this.path = parameters.path ?? null;
        this.component = parameters.component ?? null;
        this.children = parameters.children ?? null;
        this.beforeRouteLeave = parameters.beforeRouteLeave ?? null;
        this.beforeRouteUpdate  = parameters.beforeRouteUpdate  ?? null;
        this.beforeEnter = parameters.beforeEnter ?? null;
        this.beforeRouteEnter  = parameters.beforeRouteEnter ?? null;

        this.meta = {
            priority: parameters.priority ?? 0, // Signed integer, higher counts as more important
            hidden: parameters.hidden ?? false,
            roles: parameters.roles ?? [],
            permissions: parameters.permissions ?? [],
            label: parameters.label ?? null,
            translate: true, // translate label
            iconBefore: parameters.iconBefore ?? null,
            iconAfter: parameters.iconAfter ?? null,
            componentBefore: parameters.componentBefore ?? null,
            componentAfter: parameters.componentAfter ?? null,
            beforeEach: parameters.beforeEach ?? null, // beforeEach
            beforeResolve: parameters.beforeResolve ?? null, // beforeResolve
            afterResolved: parameters.afterResolved ?? null // afterEach
        };
    }
}

class RedirectRoute {
    constructor(parameters) {
        this.name = parameters.name ?? null;
        this.path = parameters.path ?? null;
        this.redirect = parameters.redirect;

        this.meta = {
            hidden: parameters.hidden ?? true,
            roles: parameters.roles ?? [],
            permissions: parameters.permissions ?? [],
            label: parameters.label ?? null,
            translate: true, // translate label
            iconBefore: parameters.iconBefore ?? null,
            iconAfter: parameters.iconAfter ?? null,
        };
    }
}

export {
    Route,
    RedirectRoute
};
